import ApiServer from "../ApiServer.ts";
import * as libLocation from "../lib/location.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import { markInvalidNative } from "../util/forms.ts";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as Html from "../util/Html.ts";
import * as CustomInput from "../util/CustomInput.ts";
import {transform} from "../handlebars_family.ts";

var inviteModal : modal.DomModal;

ApiServer["custom.invite"] = function(form: HTMLFormElement){
  const email = form.querySelector("input[name='email'], input[name='phone']") as HTMLInputElement;

  ApiServer.famsendinvite.prepare({
    role:"Unknown",
    deviceComposerUsed:false
  })(form,
    async function(){
      amplify.publish('familyChange')
      modal.closeDomModal(inviteModal);
      var [refreshed,tpl] = await Promise.all([libLocation.refresh(),import("../modal/invite_done.mustache")])
      modal.openDomModal(tpl);
    },
    function(err){
      if(err.code==='17'){
        markInvalidNative(email, i18n.get("invitationJs.errorEmail"));
      }else if(err.code==='19'){
        markInvalidNative(email, i18n.get("invitationJs.errorAlreadyInvited"));
      }else if(err.code==='12'){
        markInvalidNative(email, i18n.get("invitationJs.errorAlreadyInFamily"));
      }else if(err.code==='-23006'){
        markInvalidNative(email, i18n.get("invitationJs.-23006"));
      }else if(err.code==='505'){
        //quota reached KO_LIMIT
        modal.closeDomModal(inviteModal);
      }else{
        markInvalidNative(email, i18n.get("fw2.defaultError"));
      }
    }
  )
}
ApiServer["custom.invitenoemailstep1"] = function(form: HTMLFormElement){
  const firstnameInput = form.querySelector("input[name='firstname']") as HTMLInputElement;
  const birthdayInput = form.querySelector("input[name='birthday']") as HTMLInputElement;
  const pictureInput = form.querySelector("input[name='picture']") as HTMLInputElement;

  const datas = {
      firstname: firstnameInput.value,
      birthday: birthdayInput ? CustomInput.getDateValue(birthdayInput) : null,
      picture: pictureInput.files?.[0],
      role: 'Unknown'
  };

  import("../modal/invite_noemail2.mustache").then(function(tpl){
    modal.closeDomModal(inviteModal);
    inviteModal = modal.openDomModal(tpl,datas);
  });
  ApiServer["custom.invitenoemailstep2"] = function(form: HTMLFormElement){
    const inputs = form.querySelectorAll("input");
    const identifierInput = inputs[0] as HTMLInputElement;
    const passwordInput = inputs[1] as HTMLInputElement;

    datas.identifier = identifierInput.value;
    datas.password = passwordInput.value;

    if(datas.identifier.indexOf('@') > -1){
      markInvalidNative(identifierInput, "Email rejected");
      return;
    }

    ApiServer.accinvite(datas, async function(){
      amplify.publish('familyChange');
      const [refreshed, tpl] = await Promise.all([libLocation.refresh(), import("../modal/invite_noemaildone.mustache")]);
      modal.openDomModal(tpl, datas);

    }, function(err){
      if(err.code === "2"){
        markInvalidNative(identifierInput, i18n.get("errors.identifierUnavaible"));
      }else if(err.code === '21'){
        markInvalidNative(identifierInput, i18n.get("errors.identifierInvalid"));
      }else{
        throw err;
      }
    });
  }
}

async function invite(){
  var tpl = await import("../modal/invite_member.mustache")
  modal.closeDomModal(inviteModal);
  inviteModal = modal.openDomModal(tpl,{editable:true});
}
async function invitenoemail(){
  var tpl = await import("../modal/invite_noemail.mustache")
  modal.closeDomModal(inviteModal);
  inviteModal = modal.openDomModal(tpl,{editable:true});
}
async function invitelink(){
  var [tpl,bean] = await Promise.all([
    import("../modal/dialog_share.mustache"),
    ApiServer.famgetinvitationlinkbean()
  ])
  modal.closeDomModal(inviteModal);
  modal.openDomModal(tpl,{
    title: 'invite_link.title',
    message:transform(i18n.get('invite_link.text'),bean),
    link:bean.link,
    pictureUrl:FwDatas.getFamily().coverUri
  });
}


Html.registerDom({
  invite,
  invitenoemail,
  invitelink,
  async invitemenu(){
    var button = await modal.pick({
      title:"invite_menu.title",
      cssClass:"large",
      gap:"var(--space-s)",
      button:[
        {
          title:"invite_menu.bymailtitle",
          text:"invite_menu.bymailtext",
          bigimage:"/images/invite_email.png",
          bigimagecss:"background-color:#75D6C7;",
          onclick:invite
        },
        {
          title:"invite_menu.byaccounttitle",
          text:"invite_menu.byaccounttext",
          bigimage:"/images/invite_account_creation.png",
          bigimagecss:"background-color:#FCCCAE;",
          onclick:invitenoemail
        },
        {
          title:"invite_menu.bylinktitle",
          text:"invite_menu.bylinktext",
          bigimage:"/images/invite_link.png",
          bigimagecss:"background-color:#AEC6FC;",
          onclick:invitelink
        }
      ]});
    if(button){
      button.onclick()
    }
  },

});